









































import Vue from 'vue';
import Pedido from '@/models/Pedido';
import IconClose24 from '@/components/icons/IconClose24.vue';
import { propOfType } from '@/services/utils';

export default Vue.extend({
  props: {
    pedido: propOfType<Pedido>(),
    href: String,
  },
  components: {
    IconClose24,
  },
  methods: {
    onConfirm() {
      window.open(this.href, '_blank');
      this.$emit('close');
    },
  },
});
